export function isEmptyMetadataValue(value: unknown): boolean {
  if (value == null || value === '') {
    return true;
  }
  if (Array.isArray(value)) {
    return value.every(
      (item) => item === null || item === undefined || item === '',
    );
  }
  return false;
}
